import Swiper from "swiper/bundle";

const initInfoSlider = () => {
  // Swiperのコンテナ要素がページに存在するか確認
  const swiperContainer = document.querySelector(".js-info-slider");
  if (!swiperContainer) {
    // 要素がなければ何もしない
    return;
  }

  // Swiperを初期化
  const mySwiper = new Swiper(".js-info-slider", {
    // grabCursor: true,
    // loop: true,
    // autoplay: true,
    speed: 800,
    autoplay: {
      delay: 2000,
    },
    effect: "creative",
    direction: "vertical",
    creativeEffect: {
      limitProgress: 2,
      prev: {
        translate: [0, -30, 0], // x,y,z軸についての距離
        rotate: [0, 0, 0], // x,y,z軸に対して回転の角度
        opacity: 0, // numberを設定する
        scale: 1.1, // numberを設定する
        shadow: false, // true or false
        origin: "center top", // スライドの原点を指定
      },
      next: {
        translate: [0, 6, 0], // x,y,z軸についての距離
        rotate: [0, 0, 0], // x,y,z軸に対して回転の角度
        opacity: 0, // numberを設定する
        scale: 0.9, // numberを設定する
        shadow: false, // true or false
        origin: "center bottom", // スライドの原点を指定
      },
    },
  });

  // スライドhoverしている時は自動再生を停止
  $(".swiper-slide").on("mouseenter", function () {
    mySwiper.autoplay.stop();
  });
  $(".swiper-slide").on("mouseleave", function () {
    mySwiper.autoplay.start();
  });

  // 閉じるボタンのクリックイベント
  $(".js-info-slider-close").on("click", function (e) {
    e.preventDefault();
    $(this)
      .closest(".js-info-slider")
      .fadeOut(function () {
        $(this).remove();
      });
  });
};

window.initInfoSlider = initInfoSlider;